import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { dayChange } from '../../actions/index';

class DayTimeline extends React.Component {

    handleDayChange(event){
        this.props.dayChange(parseInt(event.target.value))
    }
    
    render() {
        let sliderMax = this.props.projectData.days.length - 1

        return(
        	<div>
	            <input 
	            type="range" 
	            className="timeslider timeslider-element"
	            min="0"
	            value={this.props.day}
	            max={sliderMax}
	            onChange={event => this.handleDayChange(event)}/>
		    </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        day         : state.day,
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        dayChange    : dayChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DayTimeline);